
import React from "react";
import { RequestAuthorizationCode } from "react-oauth2-auth-code-flow";
import { oauthClient } from "Auth";
import config from "config";

function Logout() {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('token');
    localStorage.removeItem('loginName');
    localStorage.removeItem('selectedCompanyId')
    localStorage.removeItem('selectedParentCompanyId')

    return (<RequestAuthorizationCode
      oauthClient={oauthClient}
      render={({ url }) => {
        const postLogoutRedirectUri = `${window.location.origin}/`;
        // Prefer the configured end-session endpoint (e.g. Keycloak's
        // .../protocol/openid-connect/logout). Only fall back to deriving
        // it from the authorize URL for older OpenIddict envs that don't
        // set REACT_APP_LOGOUT (its endpoint path is /connect/authorize
        // -> /connect/logout).
        const endSessionEndpoint = config.openIdDict.LOGOUT_URI
          || url.split('?')[0].replace(/authorize$/, 'logout');

        const logoutUrl = `${endSessionEndpoint}?client_id=${encodeURIComponent(config.openIdDict.CLIENT_ID)}&post_logout_redirect_uri=${encodeURIComponent(postLogoutRedirectUri)}`;
        window.location.href = logoutUrl;
        return (<div>logging out</div>)
      }}
    />
        );

}

export default Logout;
